import * as angular from "angular";

angular
  .module('bringoz.admin.agent-inventory', [
    'bringoz.admin.commons',
    'bringoz.admin.persistence'
  ])
